import React, { useState, useEffect } from "react";
import UserFilter from "./UserFilter";
import { useDispatch, useSelector } from "react-redux";
import { getDoctorList, sendBroadcastMessage } from "store/actions";
import FadeLoader from "react-spinners/FadeLoader";
import UserTable from "./detail/UserTable";
import Pagination from "components/Pagination";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
const index = ({
  message,
  sendMessage,
  handleClose,
  setSendMessage,
  clearInput,
  setIsSuccess,
  subject,
  uploadImage,
  fileType,
  attachment
}) => {
  const dispatch = useDispatch();
  const [roleId, setRoleId] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [user, setUser] = useState();
  const [broadcastResponse, setBroadcastResponse] = useState();
  const [search_text, setSearch_text] = useState("");
  const [filter, setFilter] = useState("");
  const { USER, loading, totalCount } = useSelector((state) => state.Doctor);
  const [selectedUser, setSelectedUser] = useState("Patient");

  useEffect(() => {
    if (sendMessage) {
      handleSendMessage();
      setSendMessage(false);
      handleClose();
      clearInput();
    }
  }, [sendMessage]);

  useEffect(() => {
    if (roleId === "1") {
      setSelectedUser("Patient");
    } else if (roleId === "2") {
      setSelectedUser("Doctor");
    } else if (roleId === "3") {
      setSelectedUser("Chemist");
    } else if (roleId === "") {
      setSelectedUser("All");
    }
  }, [roleId]);

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  }; 

  const handleSendMessage = async () => {
    let fileUrl = "";
    if (uploadImage) {
      await uploadData(uploadImage, "/analysis_file").then((newImage) => {
        console.log("newImagenewImagenewImage", newImage);
        fileUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${newImage}`;
      });
    }
    if(attachment){
      fileUrl = attachment;
    }
    const payload = {
      email: selectedIds,
      body: message,
      subject,
      type: selectedUser,
      attachment: fileUrl,
      fileType
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          if (res.status_code === 200) {
            setIsSuccess(true);
            toast.success(res.message);
          }
          setBroadcastResponse(res);
        }
      };
      dispatch(sendBroadcastMessage({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  useEffect(() => {
    fetchData();
  }, [roleId, currentPage, pageSize, filter]);

  const fetchData = async () => {
    const payload = {
      page: currentPage,
      record_count: pageSize,
      user_role: roleId,
      search_text: filter,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setUser(res);
        }
      };
      dispatch(getDoctorList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handleCheckboxChange = (email, isChecked) => {
    setSelectedIds((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        newSelected.add(email);
      } else {
        newSelected.delete(email);
      }
      return Array.from(newSelected); // Convert Set back to an array
    });
  };

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter(search_text);
  };

  const clearFilter = () => {
    setFilter("");
    setSearch_text("");
  };

  return (
    <>
      <div className="col-12">
        <form className="row" onSubmit={onClickFilter}>
          <div className="col-md-6 my-2 ">
            <label className="m-0" style={{ fontSize: 12 }}>
              Search:
            </label>
            <div className="iconWithText position-relative">
              <button
                type="submit"
                className="bg-transparent border-0 p-0 position-absolute"
                style={{ top: "50%", transform: "translateY(-50%)", right: 5 }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.94939 18.7933 8.90908 18.3912 7.93845C17.9892 6.96782 17.3999 6.08588 16.657 5.34299C15.9141 4.6001 15.0322 4.01081 14.0615 3.60877C13.0909 3.20672 12.0506 2.99979 11 2.99979C9.94939 2.99979 8.90908 3.20672 7.93845 3.60877C6.96782 4.01081 6.08588 4.6001 5.34299 5.34299C3.84266 6.84332 2.99979 8.87821 2.99979 11C2.99979 13.1218 3.84266 15.1567 5.34299 16.657C6.84332 18.1573 8.87821 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z"
                    stroke="grey"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              {/* <button
                onClick={() => clearFilter()}
                type="button"
                className="btn btn-primary btn-lg"
              >
                Clear Search
              </button> */}
              <input
                className="form-control"
                name="search_text"
                onChange={(e) => setSearch_text(e.target.value)}
                value={search_text}
                placeholder="Search using name, email..."
              />
            </div>
          </div>
          <div className="col-md-6 my-2">
            <UserFilter
              setRoleId={setRoleId}
              setCurrentPage={setCurrentPage}
              setSelectedIds={setSelectedIds}
            />
          </div>
        </form>
      </div>
      {loading && (
        <div className="main-loaderd  d-flex align-items-center justify-content-center py-4">
          <FadeLoader size={1000} />
        </div>
      )}
      {!loading && USER?.users && USER?.users?.length && (
        <UserTable
          data={USER.users}
          roleId={roleId}
          selectedIds={selectedIds}
          handleCheckboxChange={handleCheckboxChange}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      )}
      {!loading && USER?.length === 0 && (
        <p className="text-center py-5">No User Found</p>
      )}
      {!loading && USER?.users && USER?.users?.length > 0 && (
        <Pagination
          pageCount={Math.ceil(USER?.total_record_count / pageSize)}
          onPageChange={handlePageChange}
          itemsPerPage={pageSize}
          totalItems={USER?.total_record_count}
          currentPage={currentPage}
        />
      )}
    </>
  );
};
export default index;
